import { createHashHistory } from 'history';
import { applyMiddleware, createStore } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import rootReducer from '../reducers';

import Raven from 'raven-js';
import createRavenMiddleware from 'raven-for-redux';
Raven.config('https://d046a5b00333411586a16427bd9ca650@sentry.io/277553').install();

import { createMiddleware as createPdfMiddleware } from '../middlewares/pdf/index';
import { createMiddleware as createProjectMiddleware } from '../middlewares/project';
import { createMiddleware as createAppMiddleware } from '../middlewares/app';
import { createMiddleware as createFetchMiddleware} from '../middlewares/fetch-middleware';
import { createMiddleware as createCalculationMiddleware} from '../middlewares/calculation';
import { createMiddleware as createPlaneMiddleware} from '../middlewares/result/plane';
import { createMiddleware as createPipeMiddleware} from '../middlewares/result/pipe';
import { createMiddleware as createDuctMiddleware} from '../middlewares/result/duct';
import { createMiddleware as createTankMiddleware} from '../middlewares/result/tank';
import { createMiddleware as createArchiveMiddleware} from '../middlewares/archive';
import { createMiddleware as createUserMiddleware} from '../middlewares/user';

export const history = createHashHistory();
const middleware = routerMiddleware(history);
const pdfMiddleware = createPdfMiddleware({});
const projectMiddleware = createProjectMiddleware({});
const appMiddleware = createAppMiddleware({});
const fecthMiddleware = createFetchMiddleware({});
const calculationMiddleware = createCalculationMiddleware({});
const planeMiddleware = createPlaneMiddleware({});
const pipeMiddleware = createPipeMiddleware({});
const ductMiddleware = createDuctMiddleware({});
const tankMiddleware = createTankMiddleware({});
const archiveMiddleware = createArchiveMiddleware({});
const userMiddleware = createUserMiddleware({});

export function configureStore(initialState) {
    return createStore(
        rootReducer,
        initialState,
        applyMiddleware(
            	middleware,
                appMiddleware,
                pdfMiddleware,
                projectMiddleware,
                fecthMiddleware,
                calculationMiddleware,
                planeMiddleware,
                pipeMiddleware,
                ductMiddleware,
                tankMiddleware,
                archiveMiddleware,
                userMiddleware,

                createRavenMiddleware(Raven, {
                  stateTransformer: action => {
                    return {
                      project: action.project,
                    };
                  }
                }),
            ),
    );
}
